<template>
  <div>
    <a-button class="top_btn" type="primary" @click="()=>{  visibleForm = true; titleForm='添加' }" v-has="'btn_add'">
      添加
    </a-button>
    <a-table :columns="columns" :data-source="data" :loading="loading" :pagination="pagination" rowKey="id">
      <span slot="list_order" slot-scope="text, record">
        <a-input   v-model="record.list_order" class="inputs" size="small"/>
      </span>
      <span slot="action" slot-scope="text, record">
          <i v-if="$_hasAll(['btn_role','btn_edit','btn_delete'])" style="color:#838383">暂无操作权限</i>
          <a @click="(record) => { visbleTree = true; titleForm=`${text.name}-权限设置`;roleId=text.id;}"
             v-has="'btn_role'">权限设置<a-divider type="vertical"/></a>
          <a @click="(record)=>{visibleForm = true; titleForm='修改'; editId=text.id ; }" v-has="'btn_edit'">编辑<a-divider type="vertical"/></a>
          <a-popconfirm
              title="此操作将永久删除, 是否继续?"
              ok-text="确定"
              cancel-text="取消"
              @confirm="confirm(record)"
              @cancel="()=>{}">
              <a v-has="'btn_delete'">删除</a>
          </a-popconfirm>
        </span>
    </a-table>
    <TreeForm
        :visbleTree="visbleTree"
        :title="titleForm"
        :roleId="roleId"
        @changVisible=" () => {
          this.visbleTree = false;
          this.roleId='';
          this.getList(pagination.current)
        }"/>
  </div>
</template>

<script>
import API from "./api";
import TreeForm from "./components/TreeForm"
import { removeById } from "@/utils/utils"
import { orderList } from "../../../utils/utils"
const columns = [
  {
    title: "ID",
    dataIndex: "id",
    width: "10%",
    ellipsis: true,
    key: "id"
  },
  {
    title: "名称",
    dataIndex: "name",
    ellipsis: true,
    key: "name"
  },
  {
    title: "操作",
    key: "action",
    width: "200px",
    scopedSlots: { customRender: "action" }
  }
];
export default {
  name: 'KshUserRoles',
  data() {
    return {
      disabledStatus: false,
      pagination: {
        pageNo: 1,
        pageSize: 20,
        onShowSizeChange: (pageSize) => (this.pageSize = pageSize),
        onChange: this.getList.bind(this),
        total: 0,
        current: 0,
        size: "small",
        showTotal: total => `共 ${total} 条`,
        showQuickJumper: true
      },
      visibleForm: false,
      titleForm: "",
      loading: true,
      editId: null,
      roleId: null,
      visbleTree: false,
      data: [],
      columns,
    }
  },
  created() {
    this.$store.state.adminleftnavnum = "/UserBackground/KshUserRoles";
    this.$nextTick(() => {
      this.disabledStatus = this.$_has('btn_status')
    });
  },
  components: { TreeForm },
  methods: {
    getList(page) {
      API.serverManagement.GET_LIST(page || 1).then(res => {
        console.log('res--', res)
        this.pagination.total = res.data.data.total
        this.pagination.pageSize = res.data.data.per_page
        this.pagination.current = res.data.data.current_page
        this.data = res.data.data.list.data
        this.loading = false
      })
    },
    confirm(row) {
      removeById(API.serverManagement.DELE, [row.id]).then(res => {
        if (res == true) {
          this.getList()
        }
      })
    }, listOrder() {
      let list_orders = []
      let sortListOrder = {id: "", list_order: ""}
      for (let i = 0; i < this.data.length; i++) {
        sortListOrder.id = this.data[i].id
        sortListOrder.list_order = this.data[i].list_order
        list_orders.push(sortListOrder)
        sortListOrder = {}
      }
      console.log("list_orders",list_orders)
      orderList(API.serverManagement.LIST_ORDER, list_orders).then(res => {
        if (res == true) {
          this.getList()
        }
      })
    },
  },

  mounted() {
    this.getList()
  }
}
</script>
